import React from "react";
import { useTranslation } from "react-i18next";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line

import mainBanner from "../../images/main-banner.png"; // Import the image

// Container for the hero section background and layout
const Container = styled.div`
	${tw`relative bg-center bg-cover h-screen flex items-center justify-center`}
	background-image: url(${mainBanner});
`;

// Heading component with conditional font size based on language
const HeadingBase = styled.h1`
	${(props) =>
		props.isArmenian
			? tw`text-2xl text-left max-w-5xl sm:text-3xl lg:text-4xl font-bold leading-none text-white`
			: tw`text-3xl text-left max-w-5xl sm:text-5xl lg:text-5xl font-bold leading-none text-white`}
	span {
		${tw`inline-block mt-2`}
	}
`;

// Dark overlay for better text readability
const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-gray-900 opacity-50`;

// Hero section container
const HeroContainer = tw.div`z-20 relative max-w-screen-xl lg:max-w-screen-xl w-full flex flex-col items-start mx-auto`;

// Flexbox container for layout
const TwoColumn = tw.div`pt-24 pb-32 px-4 flex justify-start items-center w-full`;

// Left column (main content)
const LeftColumn = tw.div`w-full lg:w-2/3`;

// Slanted background style for highlighted text
const SlantedBackground = styled.span`
	${tw`relative text-blue-600 px-4 py-2`}
	&::before {
		content: "";
		${tw`absolute inset-0 bg-gray-100 transform -skew-x-12 -z-10`}
	}
`;

// Notification style
const Notification = tw.span`inline-block my-4 pl-3 py-1 text-gray-300 border-l-4 border-blue-700 font-medium text-sm`;

// Primary action (call-to-action) button style
const PrimaryAction = tw.button`
  px-8 py-3 mt-10 text-sm sm:text-base sm:mt-16 sm:px-8 sm:py-4 bg-blue-700 text-white font-bold rounded shadow
  transition duration-300 hover:bg-blue-600 focus:outline-none focus:shadow-outline
`;

export default () => {
	const { t, i18n } = useTranslation(); // Using i18n to detect current language

	const isArmenian = i18n.language === "am" || i18n.language === "hy"; // Adjust based on your locale

	// Smooth scroll to contact section
	const scrollToContact = () => {
		const contactSection = document.getElementById("contact");
		if (contactSection) {
			contactSection.scrollIntoView({ behavior: "smooth" }); // Scroll smoothly to the contact section
		}
	};

	return (
		<Container>
			<OpacityOverlay />
			<HeroContainer>
				<TwoColumn>
					<LeftColumn>
						{/* Notification section */}
						<Notification>{t("hero.notification")}</Notification>

						{/* Heading with conditional font size based on the language */}
						<HeadingBase isArmenian={isArmenian}>
							<span>{t("hero.mainPart1")}</span>
							<br />
							<SlantedBackground>{t("hero.mainPart2")}</SlantedBackground>
						</HeadingBase>

						{/* Call-to-action button */}
						<PrimaryAction onClick={scrollToContact}>
							{t("hero.cta")}
						</PrimaryAction>
					</LeftColumn>
				</TwoColumn>
			</HeroContainer>
		</Container>
	);
};
